var _defs, _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-094d09e1-dad7-4610-89bf-963872b34de1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-503fb88b-c45e-4bc9-a054-2cf237830604 {\r\n        fill: #f8f9fc;\r\n      }\r\n\r\n      .uuid-0841762e-f811-48c2-ba85-97bbbc9804b1 {\r\n        fill: #454746;\r\n      }\r\n\r\n      .uuid-ac237377-fad9-4878-808b-dd2de1b8b8ef {\r\n        fill: red;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-ac237377-fad9-4878-808b-dd2de1b8b8ef",
    cx: 540.01,
    cy: 540,
    r: 424.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-0841762e-f811-48c2-ba85-97bbbc9804b1",
    d: "M540,1080C242.25,1080,.02,837.73.02,539.98S242.25,0,540,0s539.98,242.23,539.98,539.98-242.23,540.02-539.98,540.02ZM540,42.43c-274.34,0-497.55,223.21-497.55,497.55s223.21,497.59,497.55,497.59,497.55-223.21,497.55-497.59S814.34,42.43,540,42.43Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-503fb88b-c45e-4bc9-a054-2cf237830604",
    d: "M585.59,608.02l11.78-357.96c.77-67.86-100.66-67.7-99.86,0l11.77,357.96c2.29,48.5,74.07,48.52,76.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-503fb88b-c45e-4bc9-a054-2cf237830604",
    d: "M547.43,712.17c-32.52,0-58.88,26.36-58.88,58.89s26.36,58.88,58.88,58.88,58.88-26.36,58.88-58.88-26.36-58.89-58.88-58.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.34ff6916db384ba5c126b91d2a26e094.svg";
export { ForwardRef as ReactComponent };